// FAQ Block Accordion Functionality
document.addEventListener('DOMContentLoaded', function() {
    const faqBlocks = document.querySelectorAll('.faq-block__accordion');
    
    faqBlocks.forEach(function(accordion) {
        const items = accordion.querySelectorAll('.faq-block__item');
        
        items.forEach(function(item) {
            const question = item.querySelector('.faq-block__question');
            const answer = item.querySelector('.faq-block__answer');
            
            if (question && answer) {
                // Function to close an item smoothly
                function closeItem(itemToClose) {
                    const answerToClose = itemToClose.querySelector('.faq-block__answer');
                    const questionToClose = itemToClose.querySelector('.faq-block__question');
                    
                    if (answerToClose && questionToClose) {
                        // Set current height for smooth transition
                        const currentHeight = answerToClose.scrollHeight;
                        answerToClose.style.maxHeight = currentHeight + 'px';
                        
                        // Force reflow
                        answerToClose.offsetHeight;
                        
                        // Close with animation
                        requestAnimationFrame(function() {
                            answerToClose.style.maxHeight = '0px';
                            itemToClose.classList.remove('active');
                            questionToClose.setAttribute('aria-expanded', 'false');
                        });
                    }
                }
                
                // Function to open an item smoothly
                function openItem(itemToOpen) {
                    const answerToOpen = itemToOpen.querySelector('.faq-block__answer');
                    const questionToOpen = itemToOpen.querySelector('.faq-block__question');
                    
                    if (answerToOpen && questionToOpen) {
                        // Get natural height
                        answerToOpen.style.maxHeight = '0px';
                        answerToOpen.style.opacity = '0';
                        itemToOpen.classList.add('active');
                        
                        // Force reflow
                        answerToOpen.offsetHeight;
                        
                        // Get the natural height
                        const naturalHeight = answerToOpen.scrollHeight;
                        
                        // Open with animation
                        requestAnimationFrame(function() {
                            answerToOpen.style.maxHeight = naturalHeight + 'px';
                            answerToOpen.style.opacity = '1';
                            questionToOpen.setAttribute('aria-expanded', 'true');
                        });
                    }
                }
                
                question.addEventListener('click', function() {
                    const isActive = item.classList.contains('active');
                    
                    // Close all items in this accordion
                    items.forEach(function(otherItem) {
                        if (otherItem !== item && otherItem.classList.contains('active')) {
                            closeItem(otherItem);
                        }
                    });
                    
                    // Toggle current item
                    if (isActive) {
                        closeItem(item);
                    } else {
                        openItem(item);
                    }
                });
            }
        });
    });
});

